import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import country from './modules/country'
import home from './modules/home'
import file from './modules/file'
import requests from './modules/requests'
import fileShare from './modules/file-share'
import notification from './modules/notification'
import device from './modules/device'
import payment from './modules/payment'
import place from './modules/place'
import account from './modules/account'
import subscription from './modules/subscription'
import template from './modules/template'
import project from './modules/project'
import projectFile from './modules/project-file'
import trade from './modules/trade'
import companyFile from './modules/company-file'
import profile from './modules/profile'
import company from './modules/company'
import optionValue from './modules/option-value'
import token from './modules/token'
import timesheet from './modules/timesheet'
import schedule from './modules/schedule'
import candidate from './modules/candidate'
import jobPosting from './modules/jobPosting'
import jobBoard from './modules/jobBoard'
import tradieOtw from './modules/tradieOtw'
import plantEquipment from './modules/plantEquipment'
import externalSupervisor from './modules/externalSupervisor'
import externalTimesheet from './modules/externalTimesheet'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    country,
    home,
    file,
    requests,
    fileShare,
    notification,
    device,
    payment,
    place,
    profile,
    account,
    subscription,
    template,
    project,
    projectFile,
    trade,
    companyFile,
    company,
    optionValue,
    token,
    timesheet,
    schedule,
    candidate,
    jobPosting,
    jobBoard,
    tradieOtw,
    plantEquipment,
    externalSupervisor,
    externalTimesheet,
  },
  state: {
    controls: {
      showDrawer: true,
    },
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    },
  },
})
